export const IconExpand = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>chevronDoubleDownThick</title>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="汇丰-首页" transform="translate(-207.000000, -499.000000)">
            <g id="编组-15" transform="translate(156.000000, 496.000000)">
                <g id="编组-13" transform="translate(31.500000, 8.500000) scale(1, -1) translate(-31.500000, -8.500000) ">
                    <g id="形状结合备份" transform="translate(31.500000, 8.500000) rotate(-180.000000) translate(-31.500000, -8.500000) ">
                        <g id="编组-16" transform="translate(0.000000, 0.000000)">
                            <g id="chevronDoubleDownThick" transform="translate(0.000000, 3.000000)">
                                <rect id="Bounding_box" x="0" y="0" width="12" height="12"></rect>
                                <path d="M5.8507487,9.90703125 L10.6007487,5.15703125 L10.6007487,6.64140625 L5.8507487,11.3914062 L1.1007487,6.64140625 L1.1007487,5.15703125 L5.8507487,9.90703125 Z M5.8507487,5.75078125 L1.1007487,1.00078125 L1.1007487,2.48515625 L5.8507487,7.23515625 L10.6007487,2.48515625 L10.6007487,1.00078125 L5.8507487,5.75078125 Z" id="形状" fill-opacity="1" fill="currentColor" fill-rule="nonzero"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`

export const IconCollapse = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>chevronDoubleDownThick</title>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="汇丰-首页备份" transform="translate(-207.000000, -749.000000)">
            <g id="编组-15" transform="translate(156.000000, 746.000000)">
                <g id="编组-13" transform="translate(31.500000, 8.500000) scale(1, -1) translate(-31.500000, -8.500000) ">
                    <g id="形状结合备份" transform="translate(31.500000, 8.500000) rotate(-180.000000) translate(-31.500000, -8.500000) ">
                        <g id="编组-16" transform="translate(0.000000, 0.000000)">
                            <g id="chevronDoubleDownThick" transform="translate(0.000000, 3.000000)">
                                <rect id="Bounding_box" x="0" y="0" width="12" height="12"></rect>
                                <path d="M5.8507487,9.90703125 L10.6007487,5.15703125 L10.6007487,6.64140625 L5.8507487,11.3914062 L1.1007487,6.64140625 L1.1007487,5.15703125 L5.8507487,9.90703125 Z M5.8507487,5.75078125 L1.1007487,1.00078125 L1.1007487,2.48515625 L5.8507487,7.23515625 L10.6007487,2.48515625 L10.6007487,1.00078125 L5.8507487,5.75078125 Z" id="形状" fill-opacity="1" fill="currentColor" fill-rule="nonzero" transform="translate(5.850749, 6.196094) scale(1, -1) translate(-5.850749, -6.196094) "></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`
